/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Aborted_TitleInputs */



/**
* | output |
* | --- |
* | "Practice conversation ended" |
*
* @param {Practice_Session_Aborted_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_aborted_title = /** @type {((inputs?: Practice_Session_Aborted_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Aborted_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefengesprek beëindigd")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entretien d'entraînement terminé")
	return /** @type {LocalizedString} */ ("Practice conversation ended")
});